import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, EMPTY } from 'rxjs';
import { ErrorCodes } from '../models/error-codes.enum';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { ModalService } from '../services/modal.service';
// This interceptor inspects ALL Http request responses, looking for a specific error code (CSRF_CODE)
// This error means that either the session expired, or the request includes an invalid X-XSRF-TOKEN header
// For those cases we redirect the user to the expiration page, where we force them to reload the page
// so that the server issues a new session (and a XSRF-TOKEN cookie) that the client will use as a header in subsequent requests
export const csrfErrorResponseInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const translationService = inject(TranslocoService);
  const modalService = inject(ModalService);

  return next(req).pipe(
    catchError(err => {
      if (err.error && err.error.code === ErrorCodes.CSRF_CODE && router.url.indexOf('expiration') === -1) {
        if (!navigator.cookieEnabled) {
          modalService.openGenericModal({
            isAlert: true,
            modalTitle: "No cookies",
            modalMessage: "This website requires cookies in order to work. Please enable cookies on your browser and try again"
          });
        } else {
          // TODO: Create an /expiration route and redirect the user there
          modalService.openGenericModal({
            isAlert: true,
            modalTitle: translationService.translate('modals.session_expiration.invalid_modal.title'),
            modalMessage: translationService.translate('modals.session_expiration.invalid_modal.message'),
            confirmButtonText: translationService.translate('modals.session_expiration.invalid_modal.submit'),
            primaryAction:() => {
              location.reload();
            }
          });
        }
        return EMPTY;
      }
      throw err;
    })
  );
}
